/**
 * TanStack Query setup — global QueryClient con defaults sensibles para SISREP.
 *
 * Decisión G0 D1: TanStack Query v5 + native fetch.
 */
import { QueryClient } from '@tanstack/react-query';
import { FwaApiError } from './api.js';

export function makeQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // SISREP es read-heavy con writes batched. 30s stale time evita refetch
        // agresivo y mantiene UX responsive. Background refetch on focus permite
        // ver cambios cuando user vuelve a la pestaña.
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: true,
        retry: (failureCount, error) => {
          // No retry en 4xx (cliente error); retry network errors hasta 2 veces
          if (error instanceof FwaApiError && error.status >= 400 && error.status < 500) {
            return false;
          }
          return failureCount < 2;
        },
      },
      mutations: {
        // Mutations no se retry por defecto — Idempotency-Key permite retry seguro
        // pero la decisión de retry recae en el componente (ej: form submit con UI feedback).
        retry: false,
      },
    },
  });
}
